import React, { useState, useEffect } from 'react';
import { 
  Search, 
  Edit, 
  Eye, 
  DollarSign, 
  Calendar, 
  User, 
  BookOpen, 
  Clock, 
  Phone,
  CheckCircle, 
  XCircle, 
  History,
  CreditCard,
  Upload,
  Save,
  X,
  AlertCircle,
  FileText,
  Download,
  Trash2
} from 'lucide-react';
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import CardServicio from '../../../views/compartedRoutes/Contabilidad/cardServicio';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';

const ModuloContabilidad = () => {
  const {handleBusquedaServicios,serviciosBusqueda,getBusquedaServicios} = useContabilidadModel();
  const [buscarServicio, setBusquedaServicio] = useState('');
  const {configuracion, loadingConfiguracion} = useConfiguracion();
  
  useEffect(() =>{
      //actualizar con configuracion y numero de telefono
      getBusquedaServicios(configuracion.nombreEmpresa,'');
    },[]);

  const busquedaServicio = (e) => {
    const value = e.target.value;
    setBusquedaServicio(value);
    
    // Buscar automáticamente después de 2 caracteres
    if (value.length >= 2) {
      handleBusquedaServicios(value);
    } else if (value.length === 0) {
      // Limpiar resultados si está vacío
      handleBusquedaServicios([]);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <h1 className="text-2xl font-bold text-gray-900">Control de Servicios</h1>
        </div>
      </div>

      {/* Busqueda de servicios */}
      <label className="block text-sm font-semibold text-gray-700 mb-3">
              Busqueda de servicio
            </label>
      <div className="flex-1 relative">
                  <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Buscar por número de teléfono o nombre..."
                    className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-lg"
                    value={buscarServicio}
                    onChange={busquedaServicio}
                  />
                </div>

      {/* Grid de servicios*/}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {serviciosBusqueda.map(servicio => (
          <div key={servicio.codigo} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 p-6 hover:border-blue-200">
          
          <CardServicio servicio={servicio}/>

          </div>
        ))}
      </div>
      


    </div>
  );
};

export default ModuloContabilidad;